import { ChevronRight, Wallet } from 'lucide-react';
import { openProjectReport, projectReportHref } from '../lib/routes.js';

/**
 * Sprint 23 — bandeau « Alertes budget » de l'Accueil.
 *
 * synotis-support#34 — chaque affaire est un lien vers son rapport
 * (Rapports › Projets, `?project=<id>`, période « Depuis le début »). Un vrai
 * `<a href>` : focus clavier, Entrée, clic molette / Ctrl+clic vers un nouvel
 * onglet. Le clic simple navigue dans la SPA via `onNavigate` (sans
 * rechargement) ; sans `onNavigate`, le lien se suit normalement.
 *
 * Le périmètre des alertes (`/api/budget/alerts`) est celui du rapport
 * (niveau `delegated`) : le lien ne mène pas à un 404.
 */
export default function BudgetAlertsBanner({ alerts, onNavigate }) {
  const handleClick = (e, affaireId) => {
    if (!onNavigate) return;
    // Nouvel onglet / fenêtre : comportement natif du navigateur.
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    openProjectReport(affaireId, onNavigate);
  };

  return (
    <section
      style={{
        padding: '14px 18px',
        background: 'var(--card-bg)',
        border: '1px solid var(--warning)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-card)',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text)', fontWeight: 600 }}>
        <Wallet size={16} />
        Alertes budget
        <span style={{ color: 'var(--warning)' }}>({alerts.length})</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {alerts.map((a) => {
          const pct = a.consumptionPct != null ? Math.round(a.consumptionPct) : null;
          const color = a.status === 'over' ? 'var(--danger)' : 'var(--warning)';
          return (
            <a
              key={a.affaireId}
              href={projectReportHref(a.affaireId)}
              onClick={(e) => handleClick(e, a.affaireId)}
              title={`Ouvrir le rapport du projet « ${a.name} »`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                fontSize: 13,
                color: 'var(--text)',
                textDecoration: 'none',
                padding: '4px 6px',
                margin: '0 -6px',
                borderRadius: 'var(--radius-sm)',
                cursor: 'pointer',
              }}
            >
              <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {a.name}
                {a.code ? <span style={{ color: 'var(--text-muted)' }}> · {a.code}</span> : null}
              </span>
              <span
                style={{
                  padding: '2px 10px',
                  borderRadius: 999,
                  fontSize: 11,
                  fontWeight: 500,
                  background: color,
                  color: '#fff',
                  whiteSpace: 'nowrap',
                }}
              >
                {pct != null ? `${pct}%` : '—'}
              </span>
              <ChevronRight size={14} aria-hidden="true" style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
            </a>
          );
        })}
      </div>
    </section>
  );
}
